import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

// Externals
import PropTypes from "prop-types";
import compose from "recompose/compose";
import validate from "validate.js";
import _ from "lodash";

// Material helpers
import { withStyles } from "@material-ui/core";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  forgotPassword as forgotPasswordAction,
  confirmForgotPassword as confirmForgotPasswordAction,
  isLoading as loading
} from "../../redux/actions/authActions";

import { AUTH_ERROR_CLEAR } from "../../redux/actions/types";
import { store } from "../../index";

// Material components
import { Grid, Button, IconButton, CircularProgress, TextField, Typography } from "@material-ui/core";

// Material icons
// import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";

// Shared components
// import { Facebook as FacebookIcon, Google as GoogleIcon } from "icons";

// Component styles
import styles from "./styles";

// Form validation schema
import emailSchema from "./emailSchema";
import newPasswordSchema from "./newPasswordSchema";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";

// Service methods
// const signIn = () => {
//   return new Promise(resolve => {
//     setTimeout(() => {
//       resolve(true);
//     }, 1500);
//   });
// };

class ForgotPassword extends Component {
  state = {
    values: {
      email: "",
      newPassword: "",
      newPasswordConfirm: "",
      code: ""
    },
    touched: {
      email: false,
      newPassword: false,
      newPasswordConfirm: false,
      code: false
    },
    errors: {
      email: null,
      newPassword: null,
      newPasswordConfirm: null,
      code: null
    },
    isValid: false,
    // isLoading: false,
    submitError: null
  };

  componentDidMount() {
    store.dispatch(function(dispatch) {
      // ... which themselves may dispatch many times
      dispatch({ type: AUTH_ERROR_CLEAR });
    });
  }

  // dispatchResetError = () => {
  //   let counter = 6;
  //   const seconds = setInterval(() => {
  //     if (counter === 0) {
  //       clearInterval(seconds);
  //       // dispatch INIT_STATE
  //       console.log("Login.dispatchInitState() dispatching INIT_STATE");
  //       store.dispatch({ type: AUTH_ERROR_CLEAR });
  //     }
  //     counter = counter - 1;
  //   }, 1000);
  // };

  // renderAlert() {
  //   // consume errorMessage and then dispatch event after 4 seconds to clear the state such
  //   // that message disappears from the screen
  //   const { errorMessage } = this.props;
  //
  //   if (typeof errorMessage !== "undefined" && errorMessage !== "") {
  //     console.error("Login.renderAlert(): error! message: ", errorMessage);
  //     this.dispatchResetError();
  //
  //     return errorMessage;
  //   }
  // }

  handleBack = () => {
    const { history } = this.props;

    history.goBack();
  };

  validateEmailForm = _.debounce(() => {
    const { values } = this.state;

    const newState = { ...this.state };
    const errors = validate(values, emailSchema);

    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    this.setState(newState);
  }, 300);

  validateNewPasswordForm = _.debounce(() => {
    const { values } = this.state;

    const newState = { ...this.state };
    const errors = validate(values, newPasswordSchema);

    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    this.setState(newState);
  }, 300);

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };

    newState.submitError = null;
    newState.touched[field] = true;
    newState.values[field] = value;

    this.setState(newState, field === "email" ? this.validateEmailForm : this.validateNewPasswordForm);
  };

  handleForgotPassword = e => {
    e.preventDefault();
    this.props.loading(true);
    try {
      const { history, forgotPasswordCode } = this.props;

      const code = this.state.values.code;
      const newPassword = this.state.values.newPassword;
      const email = this.state.values.email;

      // this.setState({ isLoading: true });

      // await signIn(values.email, values.password);

      console.log("Forget.onFormSubmit() username, newPassword, code, forgotPasswordCode:", {
        email,
        newPassword,
        code,
        forgotPasswordCode
      });
      // Need to do something to log user in
      // we pass in the history function so we can navigate from forgotPasswordAction
      if (typeof forgotPasswordCode === "undefined" || forgotPasswordCode === false) {
        this.props.forgotPasswordAction(email, history);
      } else {
        this.props.confirmForgotPasswordAction(email, code, newPassword, history);
      }

      // history.push("/dashboard");
    } catch (error) {
      this.setState({
        // isLoading: false,
        serviceError: error
      });
    }
  };

  render() {
    const { classes, forgotPasswordCode, isLoading, errorMessage } = this.props;
    const { values, touched, errors, isValid } = this.state;

    const showEmailError = touched.email && errors.email;

    // const invalidForgotPasswordMessage = this.renderAlert();
    const showNewPasswordError =
      touched.newPasswordConfirm && errors.newPasswordConfirm ? errors.newPasswordConfirm[0] : false;

    // const mfaRequired = true;
    // console.log("IS_LOADING: ", this.props.isLoading(true));

    return (
      <div className={classes.root}>
        <Grid className={classes.grid} container>
          <Grid className={classes.quoteWrapper} item lg={5}>
            <div className={classes.quote}>
              <div className={classes.quoteInner}>
                <Typography className={classes.quoteText} variant="h2">
                  Automatic Speech Recognition. Natural Language Understanding.
                </Typography>
                <Typography className={classes.quoteText} variant="h1">
                  <b>Built for Enterprises.</b>
                </Typography>
                <div className={classes.person}>
                  <Typography className={classes.name} variant="body1">
                    Powered by Responsum.
                  </Typography>
                  <Typography className={classes.bio} variant="body1">
                    Commanded by you.
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid className={classes.content} item lg={7} xs={12}>
            <div className={classes.content}>
              <div className={classes.contentHeader}>
                <IconButton className={classes.backButton} onClick={this.handleBack}>
                  <ArrowBackIcon />
                </IconButton>
              </div>

              <div className={classes.contentBody}>
                {!forgotPasswordCode && (
                  <form className={classes.form} onSubmit={this.handleForgotPassword}>
                    <Typography className={classes.title} variant="h2">
                      Forgot Password
                    </Typography>
                    <Typography className={classes.subtitle} variant="body1">
                      Enter your username in form below to reset your password
                    </Typography>
                    <div className={classes.fields}>
                      <TextField
                        autoFocus
                        className={classes.textField}
                        label="Email"
                        name="email"
                        onChange={event => this.handleFieldChange("email", event.target.value)}
                        type="text"
                        value={values.email}
                        variant="outlined"
                      />
                      {showEmailError && (
                        <Typography className={classes.fieldError} variant="body2">
                          {errors.email[0]}
                        </Typography>
                      )}
                    </div>
                    {errorMessage && (
                      <Typography className={classes.submitError} variant="body2">
                        {errorMessage}
                      </Typography>
                    )}
                    {isLoading ? (
                      <CircularProgress className={classes.progress} />
                    ) : (
                      <div>
                        <Button
                          className={classes.signInButton}
                          color="primary"
                          disabled={!isValid}
                          // onClick={this.handleSignIn}
                          size="large"
                          variant="contained"
                          type="submit"
                        >
                          Reset Password
                        </Button>
                        <Typography className={classes.signUp} variant="body1">
                          You are here by accident? Return back.{" "}
                          <Link className={classes.signUpUrl} to="/sign-in">
                            Sign in
                          </Link>
                        </Typography>
                      </div>
                    )}
                  </form>
                )}

                {forgotPasswordCode && (
                  <form className={classes.form} onSubmit={this.handleForgotPassword}>
                    <Typography className={classes.title} variant="h2">
                      Forgot Password
                    </Typography>
                    <Typography className={classes.subtitle} variant="body1">
                      Enter your username in form below to reset your password
                    </Typography>
                    <div className={classes.fields}>
                      <TextField
                        autoFocus
                        className={classes.textField}
                        label="New Password"
                        name="newPassword"
                        onChange={event => this.handleFieldChange("newPassword", event.target.value)}
                        type="password"
                        value={values.newPassword}
                        variant="outlined"
                      />
                      <TextField
                        className={classes.textField}
                        label="Confirm New Password"
                        name="newPasswordConfirm"
                        onChange={event => this.handleFieldChange("newPasswordConfirm", event.target.value)}
                        type="password"
                        value={values.newPasswordConfirm}
                        variant="outlined"
                      />
                      {showNewPasswordError && (
                        <Typography className={classes.fieldError} variant="body2">
                          {errors.newPasswordConfirm[0]}
                        </Typography>
                      )}
                      <TextField
                        className={classes.textField}
                        label="Verification Code"
                        name="code"
                        onChange={event => this.handleFieldChange("code", event.target.value)}
                        type="text"
                        value={values.code}
                        variant="outlined"
                      />
                      {/*{showEmailError && (*/}
                      {/*  <Typography className={classes.fieldError} variant="body2">*/}
                      {/*    {errors.email[0]}*/}
                      {/*  </Typography>*/}
                      {/*)}*/}
                    </div>
                    {/*{invalidCredentialsMessage && (*/}
                    {/*  <Typography className={classes.submitError} variant="body2">*/}
                    {/*    {invalidCredentialsMessage}*/}
                    {/*  </Typography>*/}
                    {/*)}*/}
                    {isLoading ? (
                      <CircularProgress className={classes.progress} />
                    ) : (
                      <Button
                        className={classes.signInButton}
                        color="primary"
                        disabled={!isValid}
                        // onClick={this.handleSignIn}
                        size="large"
                        variant="contained"
                        type="submit"
                      >
                        Reset Password
                      </Button>
                    )}
                  </form>
                )}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

ForgotPassword.propTypes = {
  loginAction: PropTypes.func,
  cognitoUser: PropTypes.object,
  errorMessage: PropTypes.string,
  changePassword: PropTypes.bool,
  handleSubmit: PropTypes.func,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  console.log("Login.mapStateToProps() state:", state);
  //console.log('Login.mapStateToProps() ownProps:', ownProps);
  return {
    authenticated: state.auth.authenticated,
    forgotPasswordCode: state.auth.forgotPasswordCode,
    errorMessage: state.auth.error
  };
}

function mapDispatchToProps(dispatch) {
  //console.log('Login.mapDispatchToProps() ');
  // return {
  //   ...bindActionCreators(actionCreators, dispatch),
  //   dispatch
  // };

  return {
    ...bindActionCreators({ forgotPasswordAction, confirmForgotPasswordAction, loading }, dispatch),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  compose(
    withRouter,
    withStyles(styles)
  )(ForgotPassword)
);
